import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, filter, startWith, takeUntil } from 'rxjs';

import { AnalyticsService } from '@digital-platform/rs-analytics/services';

@Component({
  selector: 'digital-platform-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();
  private router = inject(Router);
  private analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        filter((event: any) => event instanceof NavigationEnd),
        startWith(this.router)
      )
      .subscribe((value) => {
        // Only register page analytics for non JS pages
        if (value.url) {
          const regex = /[?;]/g;
          const splitUrl = value.url.split(regex);

          let rootUrl = splitUrl[0];

          rootUrl = rootUrl === '/home' ? '/' : rootUrl;

          this.analyticsService.registerPageName(rootUrl);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
